import mountTreatedDataRows from './mountTreatedDataRows'

export default {
  mountTreatedDataRows,
}
